import pdfIcon from '@peerless/ui-assets/products/pdfDocIcon.png';
import dwgIcon from '@peerless/ui-assets/products/dwgDocIcon.png';

export const useFileIcon = (fileType?: string) => {
  switch (fileType) {
    case '.pdf':
      return pdfIcon;
    case '.dwg':
      return dwgIcon;
    default:
      return pdfIcon;
  }
};
